// routes
import { PATH_ReportUser } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';
// --------------------------------------------------------------------------------------------------------

const icon = (name) => (<SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />);

const ICONS = {
    report: icon('ic_chart'),
    data: icon('ic_data'),
};

const navConfig = [
    //   GENERAL
    //   ----------------------------------------------------------------------
    {
        items: [
            {
                title: 'Data', path: PATH_ReportUser.data.root, icon: ICONS.data,
                children: [
                    { title: 'Inventory', path: PATH_ReportUser.data.inventorypage },
                    { title: 'Gross Sales', path: PATH_ReportUser.data.grosssalepage },
                ],
            },
            {
                title: 'Report', path: PATH_ReportUser.report.root, icon: ICONS.report,
                children: [
                    { title: 'Dealer Data Status Report', path: PATH_ReportUser.report.dealerdatastatusreportpage },
                    { title: 'Dealer Reported Sales', path: PATH_ReportUser.report.transactionreportpage },
                    { title: 'Dealer Reported SNS', path: PATH_ReportUser.report.dealerreportedsnsreportpage },
                    { title: 'Dealer Price Report', path: PATH_ReportUser.report.dealerreportpage },
                    { title: 'My Sales Report', path: PATH_ReportUser.report.mysalesreportpage },
                    { title: 'Request Report', path: PATH_ReportUser.report.ytddumpreportpage },
                ],
            },
        ],
    }
];

export default navConfig;